module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signin":"Sign in","signup":"Sign up","forget":"Forgot password?","or":"or"},"ru":{"signin":"Войти","signup":"Создать аккаунт","forget":"Забыли пароль?","or":"или"}}')
  delete Component.options._Ctor
}
